import { Link } from 'react-router-dom';

import { cn } from '../lib/utils';

import type { Props } from './types';

/**
 * The link a summary block offers out to the full view it summarizes -- the
 * counselor encounter view's medications and challenge response cards both show
 * a trimmed slice of a person tab, and this is how a counselor reaches the rest.
 *
 * Pass `label` only when "See all" would be ambiguous about where it goes.
 */
function SeeAllLink({ className, label = 'See all', to }: Props) {
  return (
    <Link
      className={cn(
        'flex items-center gap-1 text-sm font-medium text-blue-600 hover:underline',
        'dark:text-blue-400',
        className
      )}
      to={to}>
      {label}
    </Link>
  );
}

export { SeeAllLink };
